import type { IconNode } from '../types';

/**
 * @name shirt-t-ruler
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxMUgzYy0uNiAwLTEtLjQtMS0xVjZjMC0xLjEuOC0yLjMgMS45LTIuNkw4IDJhNCA0IDAgMCAwIDggMGw0LjEgMS40QzIxLjIgMy43IDIyIDQuOSAyMiA2djRjMCAuNi0uNCAxLTEgMWgtMyIgLz4KICA8cGF0aCBkPSJNNiAxOFY4IiAvPgogIDxwYXRoIGQ9Ik0xOCA4djEwIiAvPgogIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSI2IiB4PSIyIiB5PSIxNiIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTEwIDE2djIiIC8+CiAgPHBhdGggZD0iTTE0IDE2djIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/shirt-t-ruler
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shirtTRuler: IconNode = [
  [
    'path',
    {
      d: 'M6 11H3c-.6 0-1-.4-1-1V6c0-1.1.8-2.3 1.9-2.6L8 2a4 4 0 0 0 8 0l4.1 1.4C21.2 3.7 22 4.9 22 6v4c0 .6-.4 1-1 1h-3',
      key: '132w49',
    },
  ],
  ['path', { d: 'M6 18V8', key: 'pwosdi' }],
  ['path', { d: 'M18 8v10', key: '1ekqoy' }],
  ['rect', { width: '20', height: '6', x: '2', y: '16', rx: '2', key: '1v6ybr' }],
  ['path', { d: 'M10 16v2', key: '10xjb1' }],
  ['path', { d: 'M14 16v2', key: '12fp5e' }],
];

export default shirtTRuler;
